import React from "react";
import "../css/AdditionalDetails.css";
import addPhoto from "../images/addPhoto.png";
import advancedDetails from "../images/advancedDetails.png";
import verify from "../images/verify.png";
import returnHome from "../images/return.png";
import { useNavigate } from "react-router-dom";

export default function AdditionalDetails() {
  const navigate = useNavigate();
  return (
    <div className="exterior1">
    <div className="property-container">
      <div className="property-left-box">
        <div className="property-header">
          <p className="property-title">Congratulations! Your Property Is Under Review.</p>
          <p className="property-subtitle">
            Meanwhile, You Can Add Photos & Other Additional <br /> Details To Receive More Enquiries.
          </p>
        </div>
        <div className="property-options-box">
  <div className="options-cat">
    <img src={returnHome} alt="Return to Dashboard" />
    <button className="options-cat-name" 
    onClick={() => navigate('/')}>
      Return To Dashboard</button>
  </div>
  <div className="options-cat">
    <img src={addPhoto} alt="Add Photos/Videos" />
    <button className="options-cat-name"
    onClick={() => navigate('/additionalDetails')}>
      Add Photos/Videos</button>
  </div>
  <div className="options-cat">
    <img src={advancedDetails} alt="Advanced Details" />
    <button className="options-cat-name"
    onClick={() => navigate('/advancedDetails')}>
      Advanced Details</button>
  </div>
  <div className="options-cat">
    <img src={verify} alt="Verify Your Property" />
    <button className="options-cat-name"
    onClick={() => navigate('/verifyProperty')}>
      Verify Your Property</button>
  </div>
</div>
      </div>
      <div className="property-right-box">
    <div className="rightBox-title">
      <div>Add Photos/Videos</div>
      <div><button className="rbButton"
      onClick={() => navigate('/advancedDetails')}> 
      Skip&gt;&gt;</button> </div>
    </div>
    <div className="rb1">
      <div className="rbox"></div>
      <div className="rbox"></div>
      <div className="rbox"></div>
      <div className="rbox"></div>
      <div className="rbox"></div>
    </div>
    <div className="insbox">
      <p>Drag & Drop here</p>
      <p>or</p>
      <button className="insbutton">
        <div className="instext">Browse</div></button>
    </div>
      </div>
    </div>
    </div>
  );
}